module.exports = __webpack_public_path__ + "img/empty-box.8cac2d55.svg";